<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Header</div>
									<v-checkbox v-model="header" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Surat</div>
									<v-checkbox v-model="detailLetter" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Produk</div>
									<v-checkbox v-model="productSummary" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Catatan</div>
									<v-checkbox v-model="note" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn text large depressed class="primary col-12 mt-5" @click="printDiv(detailOpname.product_stock_opname_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="deep-purple lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5">
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="7" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
															<div>web: {{ letterHeader.letter_web }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="5" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-3 py-1 text-uppercase">Stok Opname</div>
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<div class="pb-3" v-if="detailLetter">
										<div class="border-topbot-dotted py-3 mt-5">
											<v-row>
												<v-col cols="12" class="pb-0">
													<v-row>
														<v-col cols="3" class="py-0">
															<v-row class="pl-3 justify-space-between">
																<v-col cols="10" class="pa-0"><div class="text-body-2 font-weight-bold">Nomor</div></v-col>
																<v-col cols="2" class="pa-0"><div>:</div></v-col>
															</v-row>
														</v-col>
														<v-col cols="9" class="pl-0 py-0">
															<span class="text-body-2 font-weight-bold">{{ detailOpname.product_stock_opname_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="12">
													<v-row>
														<v-col cols="3" class="py-0">
															<v-row class="pl-3 justify-space-between">
																<v-col cols="10" class="pa-0"><div class="text-body-2">Atas Nama</div></v-col>
																<v-col cols="2" class="pa-0"><div>:</div></v-col>
															</v-row>
														</v-col>
														<v-col cols="9" class="pl-0 py-0">
															<span class="text-body-2">{{ detailOpname.product_stock_opname_pic_name }}</span>
														</v-col>
														<v-col cols="3" class="py-0">
															<v-row class="pl-3 justify-space-between">
																<v-col cols="10" class="pa-0"><div class="text-body-2">Tanggal</div></v-col>
																<v-col cols="2" class="pa-0"><div>:</div></v-col>
															</v-row>
														</v-col>
														<v-col cols="9" class="pl-0 py-0">
															<span class="text-body-2">{{ detailOpname.product_stock_opname_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="mt-5 pb-3" v-if="productSummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Jumlah</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailOpname.product_stock_opname_detail" :key="product.product_stock_opname_detail_id">
															<td class="text-left">{{ product.product_stock_opname_detail_product_name }}</td>
															<td class="text-center">
																<div>{{ product.product_stock_opname_detail_quantity | toNumber }}</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="mt-5" v-if="note">
										<div class="text-body-2 font-weight-bold">Catatan</div>
										<div class="pt-2 text-body-2">
											<div v-if="detailOpname.product_stock_opname_note">{{ detailOpname.product_stock_opname_note }}</div>
											<div v-else>Tidak ada catatan</div>
										</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
// import printJS from 'print-js'
import $ from 'jquery'

export default {
	data () {
		return {
			header: true,
			detailLetter: true,
			productSummary: true,
			note: true,
		}
	},
	computed: {
		...mapState('stockOpname', ['detailOpname']),
		...mapState('common', ['letterHeader']),
	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		async printDiv(val) {
			var tempTitle = await document.title
			document.title = await val
			await $("#app").find(".v-main").css({ display: "none" });
			await window.print()
			await $("#app").find(".v-main").css({ display: "block" });
			setTimeout(() => { document.title = tempTitle }, 1000)
		},
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.header = true
				this.detailLetter = true
				this.productSummary = true
				this.note = true
			}
		}
	},
};
</script>